import React from 'react';
import PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';

const MainWrapper = ({ children }) => {
  const darkMode = useSelector((state) => state?.theme?.className);

  return (
    <div>
      {children}
      <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar
        newestOnTop
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={darkMode === 'dark' ? 'dark' : 'light'}
      />
    </div>
  );
};
MainWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
export default MainWrapper;
